// extracted by mini-css-extract-plugin
export default {"checkbox":"TaskCheckbox_checkbox__6fEF6","visual":"TaskCheckbox_visual__xmZob","successFlash":"TaskCheckbox_successFlash__Fg6jG"};